export const MACHINE_GROUP = 'MachineGroup';
//# sourceMappingURL=machine-group.js.map